var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{ref:"textarea",class:_vm.classes,domProps:{"value":_vm.currentValue},on:{"input":_vm.inputHandler}})
}
var staticRenderFns = []

export { render, staticRenderFns }